import { createAction } from 'redux-actions'
import { types } from 'features/app/store/types'
import { utils } from 'gipsy-misc'
import get from 'lodash/get'
import { translations } from 'gipsy-misc'
import logger from 'utils/logger'
import { Snackbar } from 'gipsy-ui'

export const highlightElements = createAction(types.HIGHLIGHT_ELEMENTS)

export const scrollAndHighlightElementWithId = id => async (dispatch, getState, { api }) => {
  const scrollContainer = document.getElementById('container')
  await utils.DOM.scrollWhenExistsToElementWithId(id, scrollContainer)
  dispatch(highlightElements([id]))

  setTimeout(() => {
    dispatch(highlightElements())
  }, 60 * 1000)
}

export const showSnackbar = ({
  message,
  status = 'default',
  showLogo = true,
  showClose = true,
  actionLabel = null,
  actionCallback = null,
  time = 5 * 1000
}) => async (dispatch, getState, { api }) => {
  dispatch(
    Snackbar.show(
      {
        message: message,
        status: status,
        showLogo: showLogo,
        showClose: showClose,
        actionLabel: actionLabel,
        actionCallback: actionCallback
      },
      time
    )
  )
  return
}

export const showErrorSnackbar = messagePath => async (dispatch, getState, { api }) => {
  dispatch(
    Snackbar.show(
      {
        message: get(translations, messagePath),
        status: 'error'
      },
      5000
    )
  )
  return
}

export const handleAPIError = (err, data) => (dispatch, getState, { api }) => {
  const code =
    get(err, 'data.code') && get(translations, `message.error.${err.data.code}`) ? err.data.code : 'unexpected'
  const message = get(err, 'data.message') || err.message || null
  const translatedMessage = get(translations, `message.error.${code}`).replace('{{message}}', message)
  if (message) {
    logger.error(`${code} - ${message}`, data)
  } else {
    logger.error(err, data)
  }

  dispatch(
    Snackbar.show(
      {
        message: translatedMessage,
        status: 'error'
      },
      5000
    )
  )

  return code
}



// WEBPACK FOOTER //
// ./src/features/app/store/actions.js